<template>
  <div class="page page-templates">
    <nav-bar />
    <div class="page-wrapper">
      <h3 class="wizard-step" v-if="isWizard">Шаг 2</h3>
      <h1 class="editor--title">
        Выбор шаблона страницы
      </h1>
      <p class="editor--subtitle">
        Выберите дизайн вашей страницы из подборки готовых шаблонов. Шаблоны
        представлены в нескольких категориях и имеют разный стиль.
        Воспользуйтесь «Предпросмотром», чтобы увидеть, как будет выглядеть
        страница. При необходимости вы сможете изменить внешний вид страницы в
        любой момент.
      </p>

      <template-chooser :is-wizard="isWizard" />
    </div>
  </div>
</template>

<script>
import TemplateChooser from "../components/ChooseTemplate";
import BackLink from "../components/BackLink";

export default {
  components: {
    TemplateChooser,
    BackLink
  },
  props: ["isWizard"]
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.page-templates {
  background: $background;
  @media #{$tablet} {
    padding-bottom: 0;
  }
  @media #{$mobile} {
    overflow: hidden;
  }
}

.page-wrapper {
  max-width: 1280px;
  background: #ffffff;
  border-radius: 12px;
  padding: 40px 70px;
  margin-top: 30px;
  @media #{$tablet} {
    margin-top: 0;
    margin-bottom: 0;
    border-radius: 0;
    padding: 30px;
  }
  @media #{$mobile} {
    padding: 22px 15px;
  }
}

.templates {
  &__title {
    font-size: 48px;
    font-family: Inter, sans-serif;
    text-align: left;
    font-weight: bold;
    @media #{$mobile} {
      font-size: 34px;
    }
  }
  &__text {
    font-family: Inter, sans-serif;
    font-size: 16px;
    max-width: 600px;
    line-height: 140%;
    margin-bottom: 40px;
  }
}
</style>
